import { render, staticRenderFns } from "./LocalFileUploaderModal.vue?vue&type=template&id=28080c4e&"
import script from "./LocalFileUploaderModal.vue?vue&type=script&lang=js&"
export * from "./LocalFileUploaderModal.vue?vue&type=script&lang=js&"
import style0 from "./LocalFileUploaderModal.vue?vue&type=style&index=0&id=28080c4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports